import { Component, EventEmitter, Input, Output, input, output } from '@angular/core';
import { CalendarType } from '@modules/calendar-app/types/calendar-type';
import { CalendarCellClickEvent } from '@modules/full-calendar/types/calendar-cell-click-event';
import { CalendarDropEvent } from '@modules/full-calendar/types/calendar-drop-event';
import type { CalendarEventSummaryDto } from '@sharedlib/dtos/dto/calendar-app/event.dto';

@Component({
  selector: 'stch-calendar-day',
  templateUrl: './calendar-day.component.html',
  standalone: false,
})
export class CalendarDayComponent {
  public readonly CalendarType = CalendarType;

  @Input() viewDate: Date;
  @Input() events: CalendarEventSummaryDto[];
  public readonly scrollToDate = input<Date>();
  /** Off where a date row above already names the day ("‹ Sunday [1] ›"). */
  public readonly showDayHeader = input(true);

  @Output() dateClicked = new EventEmitter<CalendarCellClickEvent>();
  @Output() dateDblClicked = new EventEmitter<Date>();
  @Output() dayNumberClicked = new EventEmitter<Date>();
  @Output() eventDropped = new EventEmitter<CalendarDropEvent>();
  protected readonly eventClicked = output<CalendarEventSummaryDto>();
  protected readonly eventDblClicked = output<CalendarEventSummaryDto>();
}
